<template>
  <div class="hello">

    <div 
      class="bgColor"
      :style="{
        'background': colorMsg,
      }"
    ></div>

    <div 
      class="bgImage"
      v-if="routerTitle[routerImage].img"
      :style="{
        'background-image': `url(${imageBg.data[imageBg.num]})`,
      }"
    ></div>

    <h1 
      class="router_title"
      v-if="routerTitle[routerImage]"
      :style="{
        'width'     : windowSize.width > 700 ? (windowSize.width*0.7 + 'px') : 'auto',
        'font-size' : windowSize.width > 700 ? '2em' : '1em',
        'background': colorTitle,
      }"
    >{{routerTitle[routerImage].title}}</h1>
        
    <router-link 
      class="meIcon" 
      to="/me"
      :style="{
        'border-color' : routerImage == 'me' ? '#42b983' : '#3d3d3d',
        'background'   : 'rgba(33, 150, 243, 0.8)',
      }"
    >
      <div 
        class="mephotoBox"
        v-if="routerImage == 'me'"
      >
      
          <div class="mephotoAni"></div>
      </div>
      <img alt="logo" width="80px" height="80px" src="../assets/img/logo/logo.png">
    </router-link>

  </div>
</template>

<script>

import Router from '../mixins/router.vue'


export default {
  name: 'HelloWorld',
  mixins: [Router],
  data () {
    return {
      colorMsg    : 'linear-gradient(45deg, #dfb7be 0%, #48afcd 33%, #c96277 66%, #c35fdf 100%)',
      colorTitle  : 'linear-gradient(45deg, #dfb7be 0%, #48afcd 33%, #c96277 66%, #c35fdf 100%)',
      imageBg     : {
        data: [
          require(`../assets/img/router/01.png`),
          require(`../assets/img/router/02.png`),
          require(`../assets/img/router/03.png`),
          require(`../assets/img/router/04.png`),
          require(`../assets/img/router/05.png`),
          require(`../assets/img/router/06.png`),
        ],
        num : 0,
      }, 
    }
  },
  props: {
    // 检测类型 + 其他验证
    routerImage: {
      type: String,
      default: 'index',
    },
    windowSize: {
      type: Object,
      default: {
        width  : 1920,
        height : 1080,
      },
    },
  },
  watch: {
    'routerImage' : function (val, oldVal) {
      this.getImageBg();
      this.colorMsg   = this.getHslArray(8);
      this.colorTitle = this.getHslArray(3);
    },
  },
  mounted: function () {
    this.getImageBg();
  },
  methods: {
    getImageBg(){
      let imageFs = () => {
        let num = Math.floor(Math.random() * (this.imageBg.data.length));
        if(this.imageBg.num == num){
          imageFs();
        }else{
          this.imageBg.num = num;
        }
      };
      imageFs();
    },
    /**
    * HSL颜色值转换为RGB
    * H，S，L 设定在 [0, 1] 之间
    * R，G，B 返回在 [0, 255] 之间
    *
    * @param H 色相
    * @param S 饱和度
    * @param L 亮度
    * @returns Array RGB色值
    */
    hslToRgb: function (H, S, L) {
      let R, G, B;
      if (+S === 0) {
        R = G = B = L; // 饱和度为0 为灰色
      } else {
        let hue2Rgb = function (p, q, t) {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1/6) return p + (q - p) * 6 * t;
          if (t < 1/2) return q;
          if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
          return p;
        };
        let Q = L < 0.5 ? L * (1 + S) : L + S - L * S;
        let P = 2 * L - Q;
        R = hue2Rgb(P, Q, H + 1/3);
        G = hue2Rgb(P, Q, H);
        B = hue2Rgb(P, Q, H - 1/3);
      }
      return [Math.round(R * 255), Math.round(G * 255), Math.round(B * 255)];
    },

    // 获取随机HSL
    randomHsl: function () {
      let H = Math.random();
      let S = Math.random();
      let L = Math.random();
      return [H, S, L];
    },

    // 获取HSL数组
    getHslArray: function (data) {
      let HSL = [];
      let hslLength = data || 4; // 获取数量
      let colorMsg  = 'linear-gradient(45deg, ';
      let lineWidth = 100 / (hslLength - 1); 

      for (let i = 0; i < hslLength; i++) {
        let ret = this.randomHsl();

        // 颜色相邻颜色差异须大于 0.25
        if (i > 0 && Math.abs(ret[0] - HSL[i - 1][0]) < 0.25) {
          i--;
          continue; // 重新获取随机色
        }
        ret[1] = 0.7 + (ret[1] * 0.2); // [0.7 - 0.9] 排除过灰颜色
        ret[2] = 0.4 + (ret[2] * 0.4); // [0.4 - 0.8] 排除过亮过暗色

        // 数据转化到小数点后两位
        ret = ret.map(function (item) {
          return parseFloat(item.toFixed(2));
        });

        HSL.push(ret);
      }
      let rgbArray = HSL.map( (item) => {
        return this.hslToRgb.apply(this, item);
      });

      for(let c = 0; c < hslLength; c++){
        let color = 'rgb(' + rgbArray[c].join(", ") + ')';
        if(c == (hslLength - 1)){

          colorMsg += (color + ' ' + '100%)');
        }else{

          colorMsg += (color + ' ' + Math.round(c * lineWidth) + '%, ');
        }
      }
      return colorMsg;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  
  .meIcon{
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    margin: 0 auto; 
    z-index: 5;
    width: 90px;
    height: 90px;
    border: 10px solid #ddd; 
    border-radius: 100%;
    overflow: hidden;
    background: rgba(33, 150, 243, 0.8);
    transition: all 0.3s;

    &:hover{
      border-color: #fff !important;
    }

    >img{
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
  >h1{
    position: absolute;
    top: 130px;
    left: 0;
    right: 0;
    margin: 0 auto; 
    z-index: 5;
    color: rgba(255, 255, 255, 1);
  }
  .router_title {
      position: relative;
      max-width: 700px;
      height: auto;
      margin: 20px auto;
      border-radius: 5px;
      z-index: 5;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: -100%;
        left: -100%;
        bottom: -100%;
        right: -100%;
        background: linear-gradient(45deg, rgba(255, 41, 0, 0.6) 0%, rgba(255, 255, 255, 0.6) 33%, rgba(64, 158, 255, 0.6) 66%, rgba(255, 255, 255, 0.6) 100%);
        background-size: 100% 100%;
        animation: bgposition 5s infinite linear alternate;
        z-index: -1;
      }

  }
  
  .bgColor{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    
    &::before {
      content: "";
      position: absolute;
      top: -100%;
      left: -100%;
      bottom: -100%;
      right: -100%;
      background: linear-gradient(45deg, rgba(255, 41, 0, 0.6) 0%, rgba(255, 255, 255, 0.6) 33%, rgba(64, 158, 255, 0.6) 66%, rgba(255, 255, 255, 0.6) 100%);
      background-size: 100% 100%;
      animation: bgposition 7s infinite linear alternate;
      z-index: -1;
    }
  }

  .bgImage{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-image: url('../assets/img/router/01.png');
    background-size: cover;
    background-repeat:no-repeat;
    background-position:center;
    background-attachment:fixed;
    transition: all 3s;
  }
  

}
@keyframes bgposition {
    0% {
        transform: translate(30%, 30%);
    }
    25% {
        transform: translate(30%, -30%);
    }
    50% {
        transform: translate(-30%, -30%);
    }
    75% {
        transform: translate(-30%, 30%);
    }
    100% {
        transform: translate(30%, 30%);
    }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

///////

@function randomNum($max, $min: 0, $u: 1) {
	@return ($min + random($max)) * $u;
}

@function randomConicGradient() {
	$n: 16 + random(16);
	$list: ();
	
	@for $i from 0 to $n {
		$list: $list, rgba(hsl(100, randomNum(250, 5, 10%), randomNum(1, 1, 1%)), randomNum(90, 0, .01));
	}
		
	@return conic-gradient($list, nth($list, 1));
}

.mephotoBox{
    position: absolute;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 80px;
    height: 80px;
    z-index: 0;    
}
.mephotoAni {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 80px;
    height: 80px;
	
	&:before, &:after {
		position: absolute;
		top: 50%; left: 50%;
		margin: -100vmax; 
		width: 200vmax; 
    height: 200vmax;
		opacity: .5;
		mix-blend-mode: overlay;
		animation: rotate randomNum(100, 25, .1s) ease-in-out infinite;
		content: '';
	}
	
	&:before { background: randomConicGradient(); }
	&:after {
		background: randomConicGradient();
		animation-duration: randomNum(100, 25, .1s);
		animation-direction: reverse;
	}
}

@keyframes rotate { 
    to { 
        transform: rotate(1turn); 
    } 
}
</style>
